<template>
  <v-snackbar v-model="snackBar.status" :color="snackBar.color" right>
    <v-icon color="white" left>{{snackBar.icon}}</v-icon>
    {{ snackBar.message }}
    <v-btn color="white" text @click="snackBar.status = false">Close</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'index',
  data: () => ({
    snackBar: {}
  }),
  created () {
    this.snackBar = this.$store.state.snackBar
  }
}
</script>

<style scoped>

</style>
